import { AppSettings } from '@/shared/app-common';
import { getApps, initializeApp } from 'firebase/app';
import { getAnalytics, isSupported, setConsent } from 'firebase/analytics';
import { myInsCookieConsentName } from '@/components/Common/CookieConsent';
import Cookies from 'js-cookie';

const isProd = process.env.NODE_ENV === 'production' && !process.env.NEXT_APP_API_HOST.includes('www-test.drfans.com');

async function initFirebase() {
  const apps = getApps();

  if (!apps.length) {
    const app = initializeApp(AppSettings.firebaseConfig);
    if (isProd) {
      const analyticsSupported = await isSupported();
      if (analyticsSupported) {
        const isAgree = Cookies?.get?.(myInsCookieConsentName) === 'true' ? 'granted' : 'denied';
        getAnalytics(app);
        setConsent({
          analytics_storage: isAgree,
          ad_storage: 'denied',
          ad_user_data: 'denied',
          ad_personalization: 'denied',
        });
      }
    }
  }
}

initFirebase();
